import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export const ThumbUpIcon = (props: SvgIconProps) => (
    <SvgIcon
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        sx={{ fontSize: 20 }}
        {...props}
    >
        <path
            d="M16.25 7.5H12.5V3.75C12.4995 3.25289 12.3017 2.77629 11.9502 2.42478C11.5987 2.07327 11.1221 1.87555 10.625 1.875H9.292C8.99142 1.87621 8.70124 1.98518 8.47417 2.18212C8.2471 2.37907 8.09819 2.65092 8.0545 2.94831L7.52619 6.64612L5.2905 10H1.25V18.75H14.375C15.5349 18.7487 16.647 18.2874 17.4672 17.4672C18.2874 16.647 18.7487 15.5349 18.75 14.375V10C18.7493 9.33719 18.4856 8.70174 18.0169 8.23306C17.5483 7.76438 16.9128 7.50074 16.25 7.5ZM5 17.5H2.5V11.25H5V17.5ZM17.5 14.375C17.4991 15.2035 17.1695 15.9978 16.5837 16.5837C15.9978 17.1695 15.2035 17.4991 14.375 17.5H6.25V10.8142L8.72363 7.10388L9.292 3.125H10.625C10.7907 3.12513 10.9496 3.19102 11.0668 3.3082C11.184 3.42539 11.2499 3.58428 11.25 3.75V8.75H16.25C16.5814 8.75041 16.8991 8.88224 17.1334 9.11657C17.3678 9.3509 17.4996 9.66861 17.5 10V14.375Z"
            fill="#616161"
        />
    </SvgIcon>
);

export const HighlightThumbUpIcon = (props: SvgIconProps) => (
    <SvgIcon
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        sx={{ fontSize: 20 }}
        {...props}
    >
        <path
            d="M1.25 10H4.375V18.75H1.25V10ZM14.375 18.75H5.625V9.49831L7.52637 6.64612L8.05469 2.94831C8.09837 2.65095 8.24725 2.37912 8.47429 2.18218C8.70132 1.98524 8.99145 1.87625 9.292 1.875H9.375C9.87211 1.87555 10.3487 2.07327 10.7002 2.42478C11.0517 2.77629 11.2495 3.25289 11.25 3.75V7.5H16.25C16.9128 7.50074 17.5483 7.76438 18.0169 8.23306C18.4856 8.70174 18.7493 9.33719 18.75 10V14.375C18.7487 15.5349 18.2874 16.647 17.4672 17.4672C16.647 18.2874 15.5349 18.7487 14.375 18.75Z"
            fill="#E4741E"
        />
    </SvgIcon>
);
